import { FETCH_NOTIFICATIONS } from "actions";

const initState = {
  myNotifications: undefined
};

export default function (state = initState, action) {
  switch (action.type) {
    case FETCH_NOTIFICATIONS:
      return {
        ...state,
        myNotifications: action.payload
      };

    default:
      return state
  }
}